export default "__VITE_ASSET__D98r$aAZ__"